import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { MenuItemBase } from '#pplx/frontend/aether/components/internal/menu/MenuItemBase.js';
import { MenuItemPrimitive } from '#pplx/frontend/aether/components/internal/menu/MenuItemPrimitive.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useCallback, useEffect, useRef } from 'react';
export function MenuSubmenuDrilldownItem({ children, textValue, disabled, onSelect, leadingAccessory, subtitle, direction = 'forward', autoFocus = false, }) {
    const { isMobileStyle } = useAetherContext();
    const itemRef = useRef(null);
    useEffect(() => {
        if (autoFocus)
            itemRef.current?.focus();
    }, [autoFocus]);
    const resolvedLeadingAccessory = direction === 'back' ? (leadingAccessory ?? $icon('arrow-left')) : leadingAccessory;
    const trailingAccessory = direction === 'forward' ? $icon('chevron-right') : undefined;
    const handleSelect = useCallback((event) => {
        if (disabled) {
            return;
        }
        // Keep the dropdown open so the consumer can swap in the next drill-down
        // view; Radix would otherwise close the menu after onSelect fires.
        event?.preventDefault();
        onSelect();
    }, [disabled, onSelect]);
    const mobileHandleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            // The mobile path renders a plain button rather than a Radix MenuItem,
            // so we implement the standard role="button" activation contract:
            // Enter and Space both trigger the item. preventDefault stops Space
            // from scrolling the page.
            e.preventDefault();
            handleSelect();
        }
    }, [handleSelect]);
    if (isMobileStyle) {
        return (_jsx(MenuItemBase, { ref: itemRef, leadingAccessory: resolvedLeadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, role: "button", tabIndex: disabled ? -1 : 0, onClick: () => handleSelect(), onKeyDown: mobileHandleKeyDown, "aria-disabled": disabled, children: children }));
    }
    return (_jsx(MenuItemPrimitive, { disabled: disabled, onSelect: handleSelect, textValue: textValue, asChild: true, children: _jsx(MenuItemBase, { ref: itemRef, leadingAccessory: resolvedLeadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, children: children }) }));
}
//# sourceMappingURL=MenuSubmenuDrilldownItem.js.map